<template>
  <div class="about">
    <div class="info">
      <div class="info-title">
        {{ $t('whatIsDF') }}
      </div>
      <div class="info-description">
        {{ $t('whatIsDFDesc') }}
      </div>
      <div class="info-actions">
        <CityscapeBtn @click="goToAnchor('#tariff')">
          {{ $t('forNewUsers') }}
        </CityscapeBtn>
        <CityscapeBtn
          :transparent="true"
          @click="goToAnchor('#investors')"
        >
          {{ $t('forInvestors') }}
        </CityscapeBtn>
      </div>
    </div>
    <video
      ref="videoAbout"
      class="video"
      no-controls
      autoplay
      loop
      playsinline
      muted
      style=""
    >
      <source
        :src="`${staticUrl}/video/speed.mp4`"
        type="video/mp4"
      />
    </video>
  </div>
</template>

<script lang="ts" setup>
import {ref, onMounted, onUnmounted} from 'vue';
import CityscapeBtn from '~/modules/CityScape/ui/CityscapeBtn.vue';
import {useRuntimeConfig} from '#imports';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const videoAbout = ref();

const rightDir = computed(() => useCookie('lang').value === 'ar');

function goToAnchor(id: string) {
  document
    .querySelector(id)
    ?.scrollIntoView({behavior: 'smooth', block: 'start'});
}

let offset: number;
const handleScroll = () => {
  if (window.scrollY >= offset) {
    videoAbout.value.pause();
  } else {
    videoAbout.value.play();
  }
};
onMounted(() => {
  offset =
    videoAbout.value!.offsetTop +
    videoAbout.value!.getBoundingClientRect().height;
  window.addEventListener('scroll', handleScroll);
});
onUnmounted(() => window.removeEventListener('scroll', handleScroll));
</script>

<style lang="scss" scoped>
::selection {
  background: #00deba; /* Safari */
}

::-moz-selection {
  background: #00deba; /* Firefox */
}
.flex-right {
  flex-direction: row-reverse;
}
.about {
  width: 100%;
  height: 300px;
  display: flex;
  // gap: 24px;
  justify-content: space-between;
  .rightDir {
    text-align: right;
  }

  .video {
    display: block;
    // width: 552px;
    // min-width: 552px;
    height: 300px;
    border-radius: 16px;
  }

  .info {
    height: 100%;
    width: 552px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;

    &-title {
      color: var(--white-theme-white-000, #fff);
      font-family: Segoe UI;
      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 57.6px */
      letter-spacing: 1.44px;
    }

    &-description {
      color: var(--white-theme-white-000, #fff);
      font-family: Segoe UI;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%; /* 22.4px */
      letter-spacing: 0.48px;

      .blue {
        color: #00deba;
        display: inline;
      }
    }

    &-actions {
      margin-top: 16px;
      display: flex;
      gap: 16px;
    }
  }
}

// @media screen and (max-width: 1000px) {
//   .about {
//     gap: 24px;
//     height: fit-content;

//     .info {
//       width: 50%;

//       .info-actions {
//         flex-direction: column;
//       }
//     }

//     .video {
//       width: 40%;
//       align-self: center;
//       height: fit-content;
//     }
//   }
// }

@media screen and (max-width: 1000px) {
  .about {
    flex-direction: column-reverse !important;
    width: 100%;
    gap: 24px;
    height: auto;

    .info {
      width: 100%;

      .info-title {
        font-size: 36px;
      }

      .info-description {
        font-size: 15px;
      }

      .info-actions {
        flex-direction: column;

        .cityscape-btn {
          width: 100%;
          font-size: 18px;
        }
      }
    }

    .video {
      width: 100%;
      height: auto;
    }
  }
}
</style>
